import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-event-details-modal',
    templateUrl: './event-details-modal.component.html',
    styleUrls: ['./event-details-modal.component.scss']
})
export class EventDetailsModalComponent extends DialogContentBase {
    @Input() public event: any;

    constructor(public dialog: DialogRef) {
        super(dialog);
    }

    public close() {
        this.dialog.close();
    }

    public get parsedContent(): string {
        const rawContent = this.event?.body?.content || this.event?.dataItem?.body?.content || '';

        // Replace block-level tags and breaks with newlines to preserve spacing
        let processedContent = rawContent
            .replace(/<\/p>|<\/div>|<br\s*\/?>/gi, '\n')
            .replace(/<p[^>]*>|<div[^>]*>/gi, '\n');

        // Strip remaining HTML tags
        const strippedContent = processedContent.replace(/<[^>]*>/g, ' ');

        // Decode common HTML entities
        const decodedContent = strippedContent
            .replace(/&nbsp;/g, ' ')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"');

        // Reduce multiple spaces and trim
        const cleanSpaces = decodedContent.replace(/[ ]+/g, ' ');

        // Remove extra new lines (replace 3+ newlines with 2, etc.)
        return cleanSpaces.replace(/\n\s*\n\s*\n+/g, '\n\n').replace(/\n\s*\n/g, '\n\n').trim();
    }
}
